// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2pq74","title":"AfterBackImages_title__3ejVf","images":"AfterBackImages_images__2p-Sz"};